import type { Dispatch, PropsWithChildren, SetStateAction } from "react";
import { createContext } from "react";
import type { ObjectLayoutState } from "./objectLayoutState";

interface Props {
  layoutState: ObjectLayoutState;
  setLayoutState: Dispatch<SetStateAction<ObjectLayoutState>>;
}

type ContextValue = Props;

const ObjectLayoutContext = createContext<ContextValue | undefined>(undefined);

export const ObjectLayoutContextProvider = ({ layoutState, setLayoutState, children }: PropsWithChildren<Props>) => (
  <ObjectLayoutContext value={{ layoutState, setLayoutState }}>{children}</ObjectLayoutContext>
);

export default ObjectLayoutContext;
